import React from 'react'

import { BrowserRouter, Routes, Route } from "react-router-dom"

import { useAuth0 } from '@auth0/auth0-react'

import Dashboard from './components/Dashboard'
import { path } from './components/Const/label'

const LoginButton = () => {
    const { loginWithRedirect } = useAuth0();

    return <button onClick={() => loginWithRedirect()}>Log In</button>;
};

const LogoutButton = () => {
    const { logout } = useAuth0();

    return (
        <button onClick={() => logout({ returnTo: window.location.origin })}>
            Log Out
        </button>
    );
};

const App = () => {
    // const { user, isAuthenticated, isLoading } = useAuth0();

    // if (isLoading) {
    //     return <div>Loading ...</div>;
    // }

    return (
        // isAuthenticated ? (
        //     <div>
        //         <img src={user.picture} alt={user.name} /> <label>{user.name} {user.email}</label>
        //         <LogoutButton />
                <BrowserRouter>
                    <Routes>
                        {/* พอเรียก push ใน history แล้ว component นั้นๆ จะไม่เรียก componentDidMount อีก */}
                        <Route exact key='default' path='/' element={<Dashboard />} />
                        {/* ทั้งประเทศ */}
                        <Route exact key='thailand' path={path.all} element={<Dashboard />} />
                        {/* เขตสุขภาพ */}
                        <Route exact key='zone' path={path.zone} element={<Dashboard />} />
                        {/* จังหวัด */}
                        <Route exact key='province' path={path.province} element={<Dashboard />} />
                        {/* โรงพยาบาล */}
                        <Route exact key='hospital' path={path.hospital} element={<Dashboard />} />
                    </Routes>
                </BrowserRouter>
        //     </div>
        // ) : (
        //     <LoginButton />
        // )
    );
};

export default App;
